import type { ReactNode } from "react";

/**
 * `maxW`/`bodyMaxW` are full Tailwind classes (not just numbers), because
 * Tailwind's JIT only generates arbitrary `max-w-[..]` values it can see as
 * literals in the source. Callers pass e.g. `maxW="max-w-[28ch]"`.
 */
export function StepHeading({
  title,
  body,
  maxW = "max-w-[22ch]",
  bodyMaxW = "max-w-[50ch]",
}: {
  title: ReactNode;
  body: ReactNode;
  maxW?: string;
  bodyMaxW?: string;
}) {
  return (
    <>
      <h2
        className={`mb-2 ${maxW} font-serif text-[clamp(1.5rem,2.8vw,2rem)] leading-tight font-extrabold tracking-[-0.02em] text-ink`}
      >
        {title}
      </h2>
      <p className={`mb-7 ${bodyMaxW} text-base leading-relaxed text-ink-muted`}>{body}</p>
    </>
  );
}
